/**
 * PRD-3334: PLG parts that are built but can be switched off. The backend's Platform_Config row
 * PLG_FEATURES is the source: GET /v1/plg/status sends it, and loadPlgSelfServe applies it here before
 * the app renders. The values below are only the fallback if that call fails. Nothing is removed.
 * - interviews: PLG customers request interviews. Off: Interview status page and menu item, and
 *   Request interview / Interview status on the Shortlist are hidden (portal customers unaffected;
 *   the backend also refuses PLG interview requests).
 * - welcomeTransition: the animated welcome screen after sign-up. Off: straight to the portal home.
 * - companyPage: the Company page. Off: its sidebar and account-menu items are hidden and /hire/company opens Home.
 */
export const PLG_FEATURES = {
  interviews: false,
  welcomeTransition: false,
  companyPage: false,
};

export type PlgFeature = keyof typeof PLG_FEATURES;

/** Takes the switches the backend sent; unknown keys and non-boolean values are ignored. */
export function applyPlgFeatures(features: unknown): void {
  if (!features || typeof features !== "object") return;
  (Object.keys(PLG_FEATURES) as PlgFeature[]).forEach((key) => {
    const value = (features as Record<string, unknown>)[key];
    if (typeof value === "boolean") PLG_FEATURES[key] = value;
  });
}
